import { defineStore } from 'pinia'
import { ref } from 'vue'
import { TBaseCatalogs } from '../types'

export const useCatalogStore = defineStore('catalogs', () => {
  const catalogs = ref<TBaseCatalogs>({
    currencies: [],
    finished_matter: [],
    galvanized: [],
    gauge: [],
    hardness: [],
    raw_material: [],
    types: [],
    unit_of_measurements: [],
    color_types: [],
    width: [],
    payment_types: [],
    foot_weight: [],
    kg_square: [],
  })

  const setCatalogs = (payload: TBaseCatalogs) => {
    catalogs.value = {
      ...catalogs.value,
      ...payload,
    }
  }

  return {
    setCatalogs,
    catalogs,
  }
})
